import { IonRow, IonButton, IonCol, IonInput } from '@ionic/react';
import React, { useState, useEffect } from 'react';
import API from '../../api/index';
import { connect } from 'react-redux';

import { fetchButtonVariables } from '../../store';
import { RootState } from '../../models/RootState';
import { ButtonVariable } from '../../models/ButtonVariables';
import NumberFormat from 'react-number-format';
import Spinner from '../../components/Spinner/Spinner';
import { toast } from 'react-toastify';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import SuccessIcon from '@material-ui/icons/CheckCircleOutline';
import ButtonVariablesIcon from '../../assets/images/icons/btnVariablesIcon.svg';
import './ButtonVariables.scss';
import SVLS_API from '../../api-services/svls-api';
import { Button } from '@material-ui/core';

type StoreProps = {
  buttonVariables: ButtonVariable[];
  fetchButtonVariables: () => void;
};

const MyBets: React.FC<StoreProps> = (props) => {
  const { buttonVariables, fetchButtonVariables } = props;

  const [loading, setLoading] = useState<boolean>(false);
  const [updateVariables, setUpdateVariables] = useState<ButtonVariable[]>();

  const updateButtonVariables = async () => {
    setLoading(true);
    for (let uV of updateVariables) {
      if (!uV.label || !uV.stake) {
        toast.error(
          <div>
            <ErrorIcon /> {'Label or Amount invalid'}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        return 0;
      }
    }
    const response = await SVLS_API.put(
      '/catalog/v2/settings/favourite-stakes/users',
      updateVariables,
      {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
      }
    );
    if ((response.status = 200)) {
      toast.success(
        <div>
          <SuccessIcon /> {'Button Variables Saved Successfully'}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
    } else {
      toast.error(
        <div>
          <ErrorIcon /> {'Something went wrong!'}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
    }
    fetchButtonVariables();
    setLoading(false);
  };

  useEffect(() => {
    fetchButtonVariables();
  }, []);

  useEffect(() => {
    setUpdateVariables(buttonVariables);
  }, [buttonVariables]);

  const updateButtonLabel = (index: number, label: string) => {
    const updateBtnVars = [...updateVariables];
    updateBtnVars[index].label = label;
    setUpdateVariables(updateBtnVars);
  };

  const updateButtonAmount = (index: number, amt: number) => {
    const updateBtnVars = [...updateVariables];
    updateBtnVars[index].stake = amt;
    setUpdateVariables(updateBtnVars);
  };

  return (
    <div className="reports-ctn button-variables-ctn">
      {loading ? <Spinner /> : null}
      <IonRow className="header-ctn">
        <div className="page-title button-page-title">
          <img src={ButtonVariablesIcon} className="button-page-icon" />
          Set Button Variables
        </div>
      </IonRow>
      <IonRow className="label-row">
        <IonCol
          sizeXl="6"
          sizeLg="6"
          sizeMd="6"
          sizeSm="6"
          sizeXs="6"
          className="btn-variable-sub-heading"
        >
          Label
        </IonCol>
        <IonCol
          sizeXl="6"
          sizeLg="6"
          sizeMd="6"
          sizeSm="6"
          sizeXs="6"
          className="btn-variable-sub-heading"
        >
          Value
        </IonCol>
      </IonRow>
      {buttonVariables.map((bV, idx) => (
        <IonRow key={'btn-var-row' + idx} className="btn-var-row">
          <IonCol
            key={'btn-var-label-col' + idx}
            sizeXl="6"
            sizeLg="6"
            sizeMd="6"
            sizeSm="6"
            sizeXs="6"
          >
            <IonInput
              key={'btn-var-label-input' + idx}
              type="text"
              value={bV.label}
              className="btn-var-label-input"
              onIonChange={(e) => updateButtonLabel(idx, e.detail.value)}
              debounce={500}
            ></IonInput>
          </IonCol>
          <IonCol
            key={'btn-var-amt-col' + idx}
            sizeXl="6"
            sizeLg="6"
            sizeMd="6"
            sizeSm="6"
            sizeXs="6"
          >
            <NumberFormat
              key={'btn-var-num-input' + idx}
              value={bV.stake}
              className="btn-var-num-input"
              allowNegative={false}
              style={{
                // height: '39px',
                border: 0,
                padding: '10px',
              }}
              onValueChange={(e) => updateButtonAmount(idx, e.floatValue)}
            ></NumberFormat>
          </IonCol>
        </IonRow>
      ))}
      <Button className="save-btn" onClick={() => updateButtonVariables()}>
        Save
      </Button>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    buttonVariables: state.exchBetslip.buttonVariables,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchButtonVariables: () => dispatch(fetchButtonVariables()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyBets);
